import { startApp } from '../app/index.ts'
import 'virtual:uno.css'

startApp()
